export var Urls = {
    Register: "account/register",
    Login: "account/login",
    Logout: "account/logout",
    ReloadUser: "account/reloadUser",
    GetBalance: "account/GetBalance",
    ChangePassword: "account/ChangePassword"
};
